import { useMutation } from '@apollo/client/react';
import { Button, Form, Input, Space, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { Password } from '../../assets/svg/login';
import { GA_EVENT, GA_LABEL, REGEX, ROUTES } from '../../common/constants';
import { Event } from '../../common/trackEvents';
import useRouter from '../../common/useRouter';
import {
  checkPasswordCharacters,
  formValidatorRules,
} from '../../common/utils';
import CheckPassword from './components/CheckPassword';
import { RESET_PASSWORD, TOKEN_VALIDATION } from './graphql/Mutations';

const { required, password: passwordRules } = formValidatorRules;

const ResetPassword = () => {
  const [selectedKey, setSelectedKey] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const { navigate, location } = useRouter();

  const getQuery = () => {
    return new URLSearchParams(location?.search);
  };
  const id = getQuery().get('uid');
  const resetToken = getQuery().get('token');

  const [tokenValid, { loading }] = useMutation(TOKEN_VALIDATION, {
    onError() {},
  });
  const [resetPassword] = useMutation(RESET_PASSWORD, {
    onCompleted() {
      Event(GA_EVENT.RESET_PASSWORD, {
        label: GA_LABEL.RESET_PASSWORD,
        // eslint-disable-next-line no-undef
        pathname: window?.location?.href,
        user_id: id,
      });
      navigate(ROUTES.LOGIN, { replace: true });
    },
    onError() {},
  });

  useEffect(() => {
    tokenValid({
      variables: {
        data: { token: resetToken, uId: Number(id), type: 'RESET_PASSWORD' },
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenValid]);

  const onFinish = ({ password }) => {
    resetPassword({
      variables: {
        data: { password, uId: Number(id), token: resetToken },
      },
      context: {
        headers: {
          'x-token': resetToken,
        },
      },
    });
  };

  const handleChange = (e) => {
    setSelectedKey(checkPasswordCharacters(e?.target?.value));
  };
  const handleFocus = () => {
    setIsVisible(true);
  };
  const handleBlur = (e) => {
    if (REGEX?.PASSWORD?.test(e?.target?.value)) {
      setIsVisible(false);
    }
  };

  return (
    <div id="reset-password-container" className="gx-login-container">
      <div className="gx-login-content">
        <div className="gx-mb-4">
          <h2>Reset Password</h2>
          <p>Enter a new password for your account</p>
        </div>
        <Spin spinning={false}>
          <Form
            name="change-password"
            layout="vertical"
            initialValues={{ remember: true }}
            onFinish={onFinish}
            className="gx-login-form gx-form-row0 set-password-form"
          >
            <Form.Item
              name="password"
              label="New Password"
              rules={[required, passwordRules]}
              className="password-input"
            >
              <Space.Compact className="width-percent-100">
                <Space.Addon>
                  <Password />
                </Space.Addon>
                <Input.Password
                  id="reset-new-password-input"
                  placeholder="Password"
                  onChange={handleChange}
                  onFocus={handleFocus}
                  onBlur={(e) => handleBlur(e)}
                />
              </Space.Compact>
            </Form.Item>
            <CheckPassword selectedKey={selectedKey} isVisible={isVisible} />
            <Form.Item
              name="retype-password"
              label="Confirm Password"
              dependencies={['password']}
              className="mt-10"
              rules={[
                required,
                passwordRules,
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || value !== getFieldValue('password')) {
                      return Promise.reject(
                        new Error('Passwords do not match'),
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Space.Compact className="width-percent-100">
                <Space.Addon>
                  <Password />
                </Space.Addon>
                <Input.Password
                  id="reset-confirm-password-input"
                  placeholder="Retype password"
                />
              </Space.Compact>
            </Form.Item>
            <div className="form-buttons d-flex mt-20">
              <Form.Item>
                <Button
                  id="reset-cancel-button"
                  className="cancel-button mr-10"
                  onClick={() => {
                    navigate(ROUTES.LOGIN);
                  }}
                >
                  Cancel
                </Button>
              </Form.Item>
              <Form.Item>
                <Button
                  id="reset-submit-button"
                  shape="round"
                  className="save-button"
                  loading={loading}
                  type="primary"
                  htmlType="submit"
                >
                  Submit
                </Button>
              </Form.Item>
            </div>
          </Form>
        </Spin>
      </div>
    </div>
  );
};

export default ResetPassword;
